import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ssrReactLazy } from 'src_common/common/mobx-utils/ResourceSSR';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';
import { FadeIn } from './FadeIn.style';

const RacingStreamGlobal = ssrReactLazy(
    async () => (await import('src/domains/sportsbook/webview/components/stream/RacingStreamGlobal')).RacingStreamGlobal
);
const CasinoMiniMain = ssrReactLazy(
    async () => (await import('src/domains/layouts/ui/uiComponents/CasinoMiniMain')).CasinoMiniMain
);

export const AppCasinoLayer = observer('AppCasinoLayer', () => {
    const common = useCommon();
    const router = StarRouter.get(common);
    const { isStreamOpen } = StreamingState.get(common);

    const name = router.currentView?.name ?? null;
    const isAnyCasinoPage = name === 'casino' || name === 'virtuals' || name === 'live-casino';
    const isRaceCard = name === 'racecard';
    const accountView = router.accountView;

    const isNotificationsList =
        router.currentView?.name === 'notifications-list' || accountView?.account === 'terms-and-conditions-promos';

    return (
        <>
            {isStreamOpen ? (
                <React.Suspense fallback={null}>
                    <RacingStreamGlobal
                        isRaceCard={isRaceCard}
                        isAnyCasinoPage={isAnyCasinoPage}
                        isNotificationsList={isNotificationsList}
                    />
                </React.Suspense>
            ) : null}

            <React.Suspense fallback={null}>
                <FadeIn>
                    <CasinoMiniMain />
                </FadeIn>
            </React.Suspense>
        </>
    );
});
